/* unplugin-vue-components disabled */import { render } from "./research.vue?vue&type=template&id=969e0ac8"
import script from "./research.vue?vue&type=script&lang=js"
export * from "./research.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ai-chat-v2/ai-assistant/research/research.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "969e0ac8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('969e0ac8', __exports__)) {
    api.reload('969e0ac8', __exports__)
  }
  
  module.hot.accept("./research.vue?vue&type=template&id=969e0ac8", () => {
    api.rerender('969e0ac8', render)
  })

}


export default __exports__